export const scrollToTop = () => {
    const body = document.querySelector("body") as HTMLElement
    // window.scrollTo(0,0)
    body.scrollIntoView({ behavior: 'smooth' })
}

